var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"height":"calc(100vh - 64px)"},attrs:{"fluid":"","grid-list-md":""}},[_c('v-tabs',{attrs:{"left":"","color":"transparent"}},[_c('v-tab',[_vm._v(" Clientes Canal ")])],1),_c('v-divider'),_c('ClientesCanal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }